// extracted by mini-css-extract-plugin
export var alignCenter = "_94-d";
export var bannerShown = "_94-6";
export var buttonContent = "_94-0";
export var cardList = "_94-1";
export var centerContent = "_94-2";
export var chevron = "_94-3";
export var closePanelButton = "_94-k";
export var conversationContextContainer = "_94-l";
export var conversationDetailContainer = "_94-4";
export var detailWrapper = "_94-7";
export var dropdownButton = "_94-e";
export var dropdownTitle = "_94-9";
export var fullHeight = "_94-5";
export var hidden = "_94-a";
export var icon = "_94-b";
export var mergeSuggestionWrapper = "_94-m";
export var panel = "_94-i";
export var portalButtonsWrapper = "_94-c";
export var right = "_94-j";
export var tableSummaryContainer = "_94-8";
export var tableSummaryHeader = "_94-g";
export var threeDotsButton = "_94-f";
export var wide = "_94-h";